import React from 'react'
import { FadeInBox } from '@components/Transitions/FadeIn'
import { Box, Icon, Paragraph } from '@ui'

export const Disclaimer = ({ children }: { children: React.ReactNode }) => {
    return (
        <FadeInBox horizontal gap paddingX paddingY="sm" rounded="sm" background="warningSubtle">
            <Box centerContent>
                <Icon type="warning" size="square_sm" />
            </Box>
            <Box centerContent>
                <Paragraph fontWeight="strong" size="sm">
                    {children}
                </Paragraph>
            </Box>
        </FadeInBox>
    )
}
